import { ShareType } from 'app/lib/types/server';
import { SET_OVERRIDE_CONFIG } from 'app/store/applicationConfig/types';
import { RESTORE_TRANSFORMATION_DEPLOYMENT } from 'app/store/deploymentHistory/types.js';
import { SHOW_ANALAYZE_SCHEMA_USAGE_FAILURE_NOTIFICATION, SHOW_ANALAYZE_SCHEMA_USAGE_SUCCESS_NOTIFICATION } from 'app/store/schemaUsage/types.js';
import { SEND_EMAIL, SET_EXPLORATION_EMAIL_SCHEDULE, SET_TRANSFORMATION_EMAIL_SCHEDULE, SAVE_SHEET_SCHEDULE, DELETE_SCHEDULE, PAUSE_SCHEDULE, SYNC_NOW } from 'app/store/shares/types.js';
import { CREATE_EVENT_SUBSCRIPTION, CREATE_SLACK_CHANNEL, DELETE_EVENT_SUBSCRIPTION, UPDATE_EVENT_SUBSCRIPTION_DELIVERY_TARGET } from 'app/store/integrations/slack/types';
import { UPDATE_PROJECT_OWNER_SUCCESS_PROJECT_OWNER_UPDATED } from 'app/store/__generated__/events';
import { TABLE_MATERIALIZATION } from 'app/store/materialize/types.js';
import { DESCRIBE_NODE_SQL } from 'app/store/notebook/types';
import { EXECUTE_EXPLORE_QUERY } from 'app/store/snowflakeQueries/types';
import { ACTIVATE_USER, DEACTIVATE_USER, DELETE_USER } from 'app/store/admin/types';
import { SET_SNOWFLAKE_USER_CREDENTIALS_ACTION_TYPE, SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_ACTION_TYPE } from 'app/store/snowflakeConfiguration/types';
import { CANCEL_QUERY } from 'app/store/snowflakeQueries/types.js';
import { UNLOAD_JOB_FAILURE_ACTION_TYPE } from 'app/store/jobs/types';

export const translation = {
    AddDatasetStarted_upload: 'File upload started',
    AddDatasetStarted_generic: 'Started adding datasets',
    AddDatasetFailed: "Adding dataset to project failed. '{{- message}}'",

    UploadDatasetSucceeded_zero: 'File uploaded successfully.',
    UploadDatasetSucceeded_one: 'File uploaded successfully with {{count}} dropped row. Invalid row written to {{errorTable}} in {{database}}.{{schema}}.',
    UploadDatasetSucceeded_other: 'File uploaded successfully with {{count}} dropped rows. Invalid rows written to {{errorTable}} in {{database}}.{{schema}}.',

    ExchangeSourceSuccess: "'{{source}}' is now a source of '{{target}}'.",
    ExchangeSourceDisconnected: "Source disconnected from '{{target}}'.",

    InitiateDownload: "Preparing download of '{{- viewName}}'…",
    DownloadFailed: "Failed to download '{{- viewName}}'. {{- message}}",
    DownloadExplorationFailed: "Failed to download '{{- targetName}}' from '{{- viewName}}'. {{- message}}",
    DownloadPrepared: "'{{- viewName}}' is ready for download",
    DownloadExplorationPrepared: "'{{- targetName}}' from '{{- viewName}}' is ready for download",

    QueryTimeout: {
        general: 'Snowflake took too long to respond.',
        timeoutAt: "Timed out after {{time}} $t(common:periods.second, {'count': {{time}} })"
    },

    SetEnvironmentSucceeded_create: "Environment '{{- name}}' successfully created.",
    SetEnvironmentSucceeded_update: "Environment '{{- name}}' successfully updated.",
    SetJobDefinitionSucceeded_create: "Job '{{- name}}' successfully created.",
    SetJobDefinitionSucceeded_update: "Job '{{- name}}' successfully updated.",

    UpdateViewNameFailed: 'Failed to update $t(glossary:dataset) name. {{- message}}',
    UpdateSpaceNameFailed: 'Failed to update $t(glossary:project) name. {{- message}}',
    UpdateGroupNameFailed: 'Failed to update group name. Name already exists.',
    ColumnRefreshFailed: 'Error retrieving datasource columns. {{- message}}',
    CalculateRowCountFailed: 'Error calculating row count. {{- message}}',

    SyncProjectStarted: 'Refreshing used sources from Snowflake',
    SyncProjectSucceeded: 'Snowflake sources are up-to-date',
    SyncProjectFailed: 'Unable to refresh used sources from Snowflake: {{- message}}',

    CreateQueryFailed: 'Unable to create new exploration query',
    UpdateQueryFailed: 'Unable to update exploration query',
    DeleteQueryFailed: 'Unable to delete exploration query',

    PromoteExplorationFailed: 'Unable to add exploration to project. {{- message}}',

    DeleteSnowflakeTableSucceeded: '{{- fqn}} has been deleted from Snowflake.',
    DeleteSnowflakeTableFailed: 'Unable to delete {{- fqn}} from Snowflake. {{- message}}',

    CreateExplorationTransformationFailed: 'Failed to create a transformation: {{- message}}',

    TableMaterializationFailed: 'Failed to materialize table. {{- errorMessage}}',

    [SEND_EMAIL.PROGRESS]: 'Your email request has been submitted',
    [SET_TRANSFORMATION_EMAIL_SCHEDULE.SUCCEEDED]: 'Mailing schedule has been successfully applied.',
    [SET_EXPLORATION_EMAIL_SCHEDULE.SUCCEEDED]: 'Mailing schedule has been successfully applied',
    [DELETE_SCHEDULE.SUCCEEDED]: {
        [ShareType.EMAIL]: 'Mailing schedule has been deleted successfully.',
        [ShareType.GOOGLE_SHEETS]: 'Google Sheet scheduling has been deleted successfully.'
    },
    [PAUSE_SCHEDULE.SUCCEEDED]: {
        [ShareType.EMAIL]: 'The scheduled emailing of this dataset has been paused.',
        [ShareType.GOOGLE_SHEETS]: 'Google Sheet scheduling of this dataset has been paused.'
    },
    [SYNC_NOW.PROGRESS]: 'Your synchronization request has been submitted',
    [SYNC_NOW.SUCCEEDED]: 'Google Sheet has been successfully synchronized',
    SyncNowGoogleSheetFailed: 'Failed to sync your Google Sheet. {{- message}}',
    SubmitMailFailed: 'Failed to deliver your email. {{- message}}',
    DeleteScheduleFailed: 'Failed to delete your schedule. {{- message}}',
    [SAVE_SHEET_SCHEDULE.SUCCEEDED]: 'Google Sheet schedule has been successfully applied.',

    [SET_OVERRIDE_CONFIG.SUCCEEDED]: 'Configuration successfully updated.',
    SetConfigFailed: 'Failed to save the configuration. {{-message}}',

    [CREATE_EVENT_SUBSCRIPTION.SUCCEEDED]: 'We will post on Slack when a Table is materialized in this Project.',
    [CREATE_SLACK_CHANNEL.SUCCEEDED]: 'Slack channel was created successfully.',
    [DELETE_EVENT_SUBSCRIPTION.SUCCEEDED]: 'We will no longer post on Slack when a Table is materialized in this Project.',
    [UPDATE_EVENT_SUBSCRIPTION_DELIVERY_TARGET.SUCCEEDED]: 'Your channel preference was updated.',

    [UPDATE_PROJECT_OWNER_SUCCESS_PROJECT_OWNER_UPDATED]: 'The ownership of "{{- projectName }}" has been successfully transferred to "{{ newOwner }}".',
    [RESTORE_TRANSFORMATION_DEPLOYMENT.PROGRESS]: 'Restore {{- fqn}} deployment in progress…',
    [RESTORE_TRANSFORMATION_DEPLOYMENT.SUCCEEDED]: '"v{{ version }} - Restored [{{- message }}]" was deployed to Snowflake successfully.',

    exploreDataDetailsButton: 'Show exploration',
    [EXECUTE_EXPLORE_QUERY.ENDED]: "Exploration query on '{{name}}' completed",
    [EXECUTE_EXPLORE_QUERY.FAILED]: "Exploration query on '{{name}}' failed",
    [CANCEL_QUERY.FAILED]: "Failed to cancel Snowflake query '{{ queryUuid }}'",

    analyzeSchemaUsageDetailsButton: 'Go to project',
    analyzeSchemaUsageStarted: 'Calculating schema usage data for {{schemaName}}.',
    [SHOW_ANALAYZE_SCHEMA_USAGE_SUCCESS_NOTIFICATION]: 'Usage data for {{schemaName}} imported to {{projectName}} as {{tableName}}',
    [SHOW_ANALAYZE_SCHEMA_USAGE_FAILURE_NOTIFICATION]: 'Failed to calculate usage data for {{schemaName}}',

    notebookSqlNodeCreated: '{{- name}} created in {{- project}}.',
    notebookSqlNodeCreatedDetailsButton: 'Go to Project',

    [TABLE_MATERIALIZATION.PROGRESS]: '{{- table}} is being materialized.',
    [TABLE_MATERIALIZATION.SUCCEEDED]: {
        completed: '{{- table}} materialization has been completed.',
        withError: '{{- table}}: {{- errorMessage}}'
    },
    [TABLE_MATERIALIZATION.FAILED]: 'Failed to materialize. {{- message}}',
    [DELETE_USER.SUCCEEDED]: 'User "{{- username}}" successfully deleted',
    [DELETE_USER.FAILED]: 'Unable to delete "{{- username}}". Check if you are authorized to do so.',

    [ACTIVATE_USER.SUCCEEDED]: '{{- username}} successfully activated',
    [ACTIVATE_USER.FAILED]: 'Unable to activate {{- username}}.',

    [DEACTIVATE_USER.SUCCEEDED]: '{{- username}} successfully deactivated',
    [DEACTIVATE_USER.FAILED]: 'Unable to deactivate {{- username}}.',

    [DESCRIBE_NODE_SQL.FAILED]: 'Error communicating with OpenAI. Please try again.',

    [SET_SNOWFLAKE_USER_CREDENTIALS_ACTION_TYPE.SUCCEEDED]: 'Successfully connected to Snowflake.',
    [SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_ACTION_TYPE.SUCCEEDED]: 'Successfully connected to Snowflake.',

    [UNLOAD_JOB_FAILURE_ACTION_TYPE]: 'Unload job with ID "{{- jobRunUid}}" failed. <navLink>Show me.</navLink>',

    ExchangeSourceFailed: 'Unable to exchange source. {{- message}}',
    sessionRoleUpdated: "We've changed the Role of the current session to match the project environment",
    sessionWhUpdated: "We've changed the Warehouse of the current session to match the project environment",

    TransferOwnershipSucceeded_one: '1 project transferred to {{- newOwner}}',
    TransferOwnershipSucceeded_other: '{{count}} projects transferred to {{- newOwner}}',

    ConvertToModelSucceeded: 'Successfully converted {{- name}} to Model',
    ConvertToModelFailed: 'Failed to convert {{- name}} to Model',

    ProjectErrors_one: 'Operation has caused <span>{{count}} downstream error</span>.',
    ProjectErrors_other: 'Operation has caused <span>{{count}} downstream errors</span>.',

    CreateMultiJoinFailed: 'Failed to create Join. {{- message}}',
    UpdateMultiJoinFailed: 'Failed to update Join. {{- message}}'
};
